module.exports = __webpack_public_path__ + "static/media/subtract-icon.8e6392eb.svg";